<script setup>
import { watch } from 'vue'
import { useGlobalHeader } from '../composable/useGlobalHeader'
const { searchQuery, searchResults, searchCityInput } = useGlobalHeader()

const emits = defineEmits(['update:searchResults'])
const props = defineProps({
  lang: { type: String, default: 'ja' }
})

watch(searchResults, (value) => {
  emits('update:searchResults', value)
})
</script>

<template>
  <section class="headerOverlayContent__search">
    <p
      class="search_tit"
      style="margin-bottom: 10px"
    >
      天気予報を検索
    </p>
    <form @submit.prevent="searchCityInput(props.lang)">
      <label
        for=""
        class="headerInputText"
      >
        <input
          id="search_sp"
          v-model="searchQuery"
          type="text"
          placeholder="都市名,郵便番号,市外局番など"
          class="form-txt"
        >
        <button type="submit">
          <img
            src="https://gvs.weathernews.jp/onebox/img/icon/icon_mushimegane.svg"
            width="30px"
            height="30px"
            class="icon"
            alt=""
          >
        </button>
      </label>
    </form>
  </section>
</template>

<style lang="scss" scoped>
.search_tit {
  margin-bottom: 10px;
  font-size: 20px;
  font-weight: bold;
}
.headerInputText {
  gap: 10px;
  display: flex;
  padding: 6px 10px;
  border: 1px solid #DFE4F0;
  border-radius: 4px;
  .form-txt {
    flex: 1;
    width: 100%;
    padding: 0;
    border: none;
    font-size: 15px;
  }
}
</style>
